import styled from 'styled-components'
import { BLACK, CRIMSON_500, LIGHT_YELLOW, NEUTRAL_100, NEUTRAL_300 } from '@styles/colors'
import { INTER } from '@styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 8px;
`

export const TitleContainer = styled.span`
  font-family: ${INTER.medium};
  color: ${NEUTRAL_300};
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: center;
`

export const OptionalText = styled.span`
  color: ${NEUTRAL_300};
`

interface InputWrapperProps {
  $isError: boolean
  $borderless?: boolean
}

export const InputWrapper = styled.div<InputWrapperProps>`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  border: ${props => props.$borderless ? 'none' : `1px solid ${props.$isError ? CRIMSON_500 : NEUTRAL_100}`};
  border-radius: 8px;
  background-color: ${props => props.$isError ? LIGHT_YELLOW : 'transparent'};
`

interface StyledInputProps {
  $isError: boolean
}

export const StyledInput = styled.input<StyledInputProps>`
  flex: 1;
  border: none;
  border-radius: 8px;
  padding: 12px 14px;
  color: ${props => props.$isError ? CRIMSON_500 : BLACK};
  font-family: ${INTER.regular};
  font-size: 13px;
  outline: none;
  background-color: transparent;
`

export const ClearButton = styled.button`
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`

export const ErrorText = styled.span`
  color: ${CRIMSON_500};
  font-family: ${INTER.regular};
  font-size: 12px;
`
